import React, { useState, useEffect } from "react";
import "./AGIndustries.css";
import { Link } from "react-router-dom";

const ITEMS_GALERIA = [
  { id: 1, img: "/imagen1.jpeg", titulo: "Colección I", categoria: "Autos" },
  {
    id: 2,
    img: "/imagen2.jpeg",
    titulo: "Colección II",
    categoria: "Retratos",
  },
];

const AGIndustries = () => {
  const [animar, setAnimar] = useState(false);
  const [menuActivo, setMenuActivo] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);

  useEffect(() => {
    const fn = () => {
      setScrolled(window.scrollY > 70);
    };

    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  // Scrollbar personalizado
  useEffect(() => {
    const thumb = document.createElement("div");
    thumb.style.cssText = `
    position: fixed;
    right: 2px;
    top: 0;
    width: 3px;
    background: rgba(139, 90, 60, 0.6);
    border-radius: 10px;
    z-index: 9999;
    pointer-events: none;
    transition: opacity 0.3s;
    opacity: 0;
  `;
    document.body.appendChild(thumb);

    let timeout;
    const updateThumb = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const percent = scrollTop / docHeight;
      const thumbHeight = Math.max(
        (window.innerHeight / document.documentElement.scrollHeight) *
          window.innerHeight,
        40,
      );
      const thumbTop = percent * (window.innerHeight - thumbHeight);
      thumb.style.height = thumbHeight + "px";
      thumb.style.top = thumbTop + "px";
      thumb.style.opacity = "1";
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        thumb.style.opacity = "0";
      }, 1000);
    };

    window.addEventListener("scroll", updateThumb);
    return () => {
      window.removeEventListener("scroll", updateThumb);
      document.body.removeChild(thumb);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuAbierto ? "hidden" : "auto";
  }, [menuAbierto]);

  const ejecutarAnimacionYLink = () => {
    setAnimar(true);
    setTimeout(() => {
      window.open("/edit", "_blank");
      setAnimar(false);
    }, 800);
  };

  const cerrar = () => setMenuAbierto(false);

  return (
    <div className={`sx-wrapper ${animar ? "efecto-salida" : ""}`}>
      {/* ══ NAVBAR ══ */}
      <nav className={`sx-nav ${scrolled ? "scrolled" : ""}`}>
        <div className="cartier-header-main">
          <div className="cartier-logo-container">
            <img
              src="/LogoHeader.png"
              alt="Cartier"
              className="cartier-logo-img"
            />
          </div>
        </div>

        

        <div className="sx-nav-content sx-nav-content--home">
          

          <div className={`sx-side-menu ${menuAbierto ? "is-open" : ""}`}>
            <Link to="/cartelera" onClick={cerrar}>
              Cartelera
            </Link>
            <Link to="/sponsors" onClick={cerrar}>
              Sponsors
            </Link>
            <Link to="/accesorios" onClick={cerrar}>
              Accesorios
            </Link>
            <Link to="/experiencias" onClick={cerrar}>
              Experiencias
            </Link>
          </div>

          <div className="sx-menu">
            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("cartelera")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/cartelera" onClick={cerrar}>
                Cartelera
                <span
                  className={`sx-arrow ${
                    menuActivo === "cartelera" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${menuActivo === "cartelera" ? "show" : ""}`}
              >
                {/* El video de fondo */}
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="sx-dropdown-video"
                >
                  <source src="/Cartelera_Fondo.mp4" type="video/mp4" />
                  Tu navegador no soporta videos.
                </video>
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/sponsors" onClick={cerrar}>
                Sponsors
                <span
                  className={`sx-arrow ${
                    menuActivo === "sponsors" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "sponsors" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("sponsors")}
              onMouseLeave={() => setTimeout(() => setMenuActivo(null), 200)}
            >
              <Link className="sx-nav-link" to="/accesorios" onClick={cerrar}>
                Accesorios
                <span
                  className={`sx-arrow ${
                    menuActivo === "accesorios" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "accesorios" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>

            <div
              className="sx-nav-item-container"
              onMouseEnter={() => setMenuActivo("experiencias")}
              onMouseLeave={() => setMenuActivo(null)}
            >
              <Link className="sx-nav-link" to="/experiencias" onClick={cerrar}>
                Experiencias
                <span
                  className={`sx-arrow ${
                    menuActivo === "experiencias" ? "open" : ""
                  }`}
                >
                  ▾
                </span>
              </Link>

              <div
                className={`sx-dropdown-bar ${
                  menuActivo === "experiencias" ? "show" : ""
                }`}
              >
                {/* Aquí agregarás tus opciones */}
              </div>
            </div>
          </div>

          <div className="sx-nav-right"></div>
        </div>
      </nav>

      {/* ══ SECCIÓN 1 ══ */}
      <section className="video-container">
        <video autoPlay muted loop playsInline className="background-video">
          <source src="/video3d.mp4" type="video/mp4" />
        </video>
      </section>

      <div style={{ height: "2cm" }}></div>

      {/* ══ SECCIÓN 2 ══ */}
      <div className="sx-gallery-grid">
        <div className="sx-item">
          <Link to="/experiencias ">
          <img src="/imagen5.jpeg" alt="" />
          </Link>
          <div class="sx-item-info">
            <h3>EXPERIENCIA VV</h3>
            <p>
              Conoce el Universo VV, creando primeras alianzas con otras bodegas
              como Orígenes & Terruños, en el parteaguas de lo que hoy son
              marcas del mismo: Festival VV, Experiencia VV, AG Gallery y Reina
              del Vino.
            </p>
          </div>
        </div>
        <div className="sx-item">
          <a href="https://www.bodegaantoniogonzalez.com/" target="_blank">
          <img src="/imagen6.jpeg" alt="" />
          </a>
          <div class="sx-item-info">
            <h3>BODEGA AG</h3>
            <p>
              Bienvenidos a San Andrés Tuxtla, Veracruz, “La Suiza Veracruzana”
              aquí nace Bodega Antonio González, la primera vinícola que potencial que
              ademas, es fundadora del Festival VV.
            </p>
          </div>
        </div>
      </div>

      <div class="sx-item-info-Home-1">
        <h3>MERCH OFICIAL</h3>
      </div>

      {/* ══ SECCIÓN 3: Catálogo de Productos ══ */}
      <section className="sx-product-catalog">
        <div className="sx-catalog-grid">
          {/* Producto 1 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <Link to="/accesorios">
                <img src="/imagen7.jpeg" alt="Producto 1" />
              </Link>
            </div>
            <div className="sx-catalog-info">
              <h3>HOODIE WHITE VV</h3>
              <p>Algodón, grabado en negro.</p>
              <span className="sx-price">$900.00 MXN</span>
            </div>
          </div>

          {/* Producto 2 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <Link to="/accesorios">
                <img src="/imagen10.jpeg" alt="Producto 2" />
              </Link>
            </div>
            <div className="sx-catalog-info">
              <h3>HOODIE YELLOW PRINT</h3>
              <p>Algodón, grabado en negro.</p>
              <span className="sx-price">$900.00 MXN</span>
            </div>
          </div>

          {/* Producto 3 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <Link to="/accesorios">
                <img src="/imagen9.jpeg" alt="Producto 3" />
              </Link>
            </div>
            <div className="sx-catalog-info">
              <h3>HOODIE FESTIVAL VV</h3>
              <p>Algodón, grabado clásico.</p>
              <span className="sx-price">$700.00 MXN</span>
            </div>
          </div>

          {/* Producto 4 */}
          <div className="sx-catalog-item">
            <div className="sx-img-wrapper">
              <Link to="/accesorios">
                <img src="/imagen8.jpeg" alt="Producto 4" />
              </Link>
            </div>
            <div className="sx-catalog-info">
              <h3>SECRET BAG VV </h3>
              <p>Bolsa secreta, limitadas.</p>
              <span className="sx-price">$500.00 MXN</span>
            </div>
          </div>
        </div>
      </section>

      <div class="sx-item-info-Home">
        <h3>EMBAJADORAS</h3>
      </div>

      {/* ══ SECCIÓN 4 ══ */}
      <section className="sx-seccion4">
        <div className="sx-gallery-grid">
          <div className="sx-item">
            <img src="/imagen11.jpeg" alt="" />
          </div>
        </div>
      </section>

      {/*SECCION 5*/}
      <section className="sx-hero">
        <div className="sx-gallery-grid">
          <div className="sx-item">
            <a href="https://theaggallery.com" target="_blank">
            <img src="/imagen2.0.jpeg" alt="" />
            </a>
            <div class="sx-item-info">
              <h3>The AG Gallery</h3>
              <p>
                Conoce la galería de arte creada por nuestro fundador con sede
                en CDMX, Santa Fé, una galería exclusiva del Festival VV,
                disfruta de intervenciones en vivo y promoción de obras
                nacionales.
              </p>
            </div>
          </div>
          <div className="sx-item">

            <Link to="/sponsors">
            <img src="/imagen3.jpeg" alt="" />
            </Link>
            <div class="sx-item-info">
              <h3>STANDS Y ZONA PICNIC</h3>
              <p>
                Aparta tu espacio, conoce las opciones y costos disponibles para
                sponsors , marcas exclusivas, emprendedores y zonas verdes
                familiares, no te quedes fuera de la Experiencia VV.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ══ FOOTER ══ */}
      <footer className="sx-footer">
        <div className="sx-footer-content">
          <span className="sx-copyright">
            Todo material y recursos fotográficos utilizados son propiedad
            exclusiva del Festival VV, MARCA REGISTRADA, queda prohibido su uso
            y descarga para otros fines de lucro, promoción y divulgación bajo
            responsabilidad legal.
          </span>
          <span className="sx-copyright">
            Festival VV — © Todos los derechos reservados.
          </span>
        </div>
      </footer>
    </div>
  );
};

export default AGIndustries;
